export default {
  type: 'Tipo',
  relevanceNo: 'Número de pedido relacionado',
  consultContent: 'Conteúdo da consulta',
  submitTime: 'Hora de envio',
  consultTypeEnum: {
    0: 'Consulta de pedido',
    1: 'Consulta de pacote',
  },
  consultStatusEnum: {
    0: 'Não processado',
    1: 'Em processamento',
    2: 'Concluído',
  },
}
